export const REQUEST_SUSPEND_TYPE = "REQUEST_SUSPEND_TYPE";
export const SET_SUSPEND_TYPE = "SET_SUSPEND_TYPE";
export const ERROR_SUSPEND_TYPE = "ERROR_SUSPEND_TYPE";
